module.exports = __webpack_public_path__ + "static/img/填写项目信息.89e31ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Doc/assets/imgs/填写项目信息.png
// module id = mF1X
// module chunks = 0